<template>
  <div class="relative rounded-[10px] border border-solid border-gray-light bg-gray-light mb-8">
    <div class="flex flex-col gap-6 p-4 md:p-6 md:flex-row">
        <div class="text-b2 mt-2 md:mt-0 md:basis-1/4">
          <h3 class="text-t6">{{ rentalObject.postalAddress }}</h3>
          <p class="text-b2">{{ rentalObject.neigbourhood }}</p>

          <div v-if="hasAnswered">
            <p>
              Du svarade:
              <span class="font-thick">{{offer.responseCode === OFFER_RESPONSE_CODES.YES ? 'Ja' : 'Nej'}}</span>
            </p>
          </div>
          <div v-else>
            <p>
              Inget svar
            </p>
          </div>
        </div>
        <div class="text-b2 mt-2 md:mt-0 flex flex-col">
         <p>Datum: <span>{{ formatDate(lastReplyDate) }}</span></p>
          <p>{{rentalObject.quantityBRA}} m&sup2, {{rentalObject.subCaption}}</p>
          {{rentalObject.rentalObjectTypeCaption}}
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import Button from '@/components/ui/button';
import IconCheckmark from '@/components/icons/IconCheckmark';
import {
  RENTALOBJECT_TYPE_CODES,
  OFFER_RESPONSE_CODES,
  RENTALOBJECT_TYPES,
} from '@/config/constants';
import OfferMixin from '@/mixins/offer';
import rentalobject from "../../mixins/rentalobject.js";

export default {
  mixins: [OfferMixin],
  props: {
    offer: {
      type: Object,
      required: false,
    },
    offerNumber: {
      type: Number,
      required: false,
    },
  },
  components: {
    Button,
    IconCheckmark,
  },
  data() {
    return {
      showLoader: false,
      showModal: {
        confirmAnswer: false,
        information: false,
      },
      failed: '',
      answered: '',
      success: false,

      OFFER_RESPONSE_CODES,
      RENTALOBJECT_TYPES,
      RENTALOBJECT_TYPE_CODES,
    };
  },
  computed: {
    rentalobject() {
      return rentalobject
    },
    ...mapGetters(['webapp_config']),
    _offer() {
      if (this.offer) return this.offer;
      else if (this.offerNumber) return this.$store.getters.getOfferByOfferNumber(this.offerNumber);
    },
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD');
    },
  },
  created() {
    if (this.offerNumber) {
      this.$store.cache.dispatch('fetchOffers').finally(() => {
        this.showLoader = false;
      });
    } else if (this.offer) {
      this.showLoader = false;
    } else {
      console.error('offer-item.vue Varken offer eller invoiceId satt :(');

      this.showLoader = false;
    }
  },
};
</script>
